import Vue from "vue"
import Vuex from "vuex"
import {getUserSession} from "@/data/repos/authUserSession"
import {getAppList} from "@/data/repos/authAppList"

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    sso: {
      userId: 0,
      sessionId: null,
    },
    userInfo: {
      userId: 0,
      userName: "",
      sessionId: "",
      expirationTimestamp: "",
      firstName: "",
      lastName: "",
      micadUser: null,
      roles: [],
    },
    appList: {},
    versions: {
      APP_VERSION: "",
      API_VERSION: "",
    },
  },
  getters: {
    sso(s) {
      return s.sso
    },
    userInfo(s) {
      return s.userInfo
    },
    appList(s) {
      return s.appList
    },
    versions(s) {
      return s.versions
    },
  },
  mutations: {
    setSSO(state, data) {
      state.sso = data
    },
    setUserInfo(state, data) {
      state.userInfo = data
    },
    setAppList(state, data) {
      state.appList = data
    },
    setVersions(state, data) {
      state.versions = data || {}
    }
  },
  actions: {
    async updateUserInfo(c) {
      const us = await getUserSession(c.state.sso.userId, c.state.sso.sessionId)
      c.commit("setUserInfo", us)
    },
    async updateAppList(c) {
      const ul = await getAppList()
      c.commit("setAppList", ul)
    },
  },
})
